module.exports = __webpack_public_path__ + "img/icon-windows.d93cec85.svg";